import { useCallback } from 'react';
import { useAppDispatch, useWebSettings } from '@shared/hooks';
import { openAuthModal, openNotifyModal } from 'library/redux/modal';

export const useAuthModal = () => {
  const dispatch = useAppDispatch();
  const { resource_name } = useWebSettings();

  const openAuth = useCallback(() =>
    // withNotifyModal?: boolean, notifyNodalProps?: NotifyModal
    {
      const doOpenAuthModal = () => dispatch(openAuthModal());
      //
      // if (withNotifyModal) {
      //   dispatch(
      //     openNotifyModal({
      //       title: 'Уведомление',
      //       confirmText: 'Авторизоваться',
      //       text: 'Для просмотра контента необходима авторизация',
      //       needClose: true,
      //       isOnConfirmShouldNotWorkOnCloseModal: true,
      //       fullWidthText: true,
      //       confirm: doOpenAuthModal,
      //       ...notifyNodalProps,
      //     })
      //   );
      // } else {
      doOpenAuthModal();
      // }
    }, [dispatch]);

  const openSuccessAuthModal = useCallback(
    ({
      cbFuOnSuccess,
      title,
      withoutReload,
    }: {
      cbFuOnSuccess?: () => void;
      title: string;
      withoutReload?: boolean;
    }) => {
      dispatch(
        openNotifyModal({
          title,
          text: `Добро пожаловать на платформу ${resource_name}.`,
          confirmText: 'Ок',
          confirm: () => {
            cbFuOnSuccess && cbFuOnSuccess();
            !withoutReload && window.location.reload();
          },
        })
      );
    },
    [resource_name, dispatch]
  );

  return {
    openAuth,
    openSuccessAuthModal,
  };
};
